module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    attrs: {
      "span": "24"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.getSettingsAddons.norcloud > 0) ? _c('el-form', {
    ref: "form",
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/norcloud/IdNor')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.getSettingsDevice.devid),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsDevice, "devid", $$v)
      },
      expression: "getSettingsDevice.devid"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/norcloud/syncTime')
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.getSettingsAddons.norcloud == '0',
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsNorCloud.sendTime),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsNorCloud, "sendTime", $$v)
      },
      expression: "getSettingsNorCloud.sendTime"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/norcloud/disable'),
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '1 ' + _vm.$l('settings/norcloud/hour'),
      "value": "60"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '12 ' + _vm.$l('settings/norcloud/hour'),
      "value": "720"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '24 ' + _vm.$l('settings/norcloud/hour'),
      "value": "1440"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/norcloud/syncData')
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "on-value": "1",
      "off-value": "0"
    },
    model: {
      value: (_vm.getSettingsNorCloud.sendData),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsNorCloud, "sendData", $$v)
      },
      expression: "getSettingsNorCloud.sendData"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/norcloud/syncRec')
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "on-value": "1",
      "off-value": "0"
    },
    model: {
      value: (_vm.getSettingsNorCloud.sendRec),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsNorCloud, "sendRec", $$v)
      },
      expression: "getSettingsNorCloud.sendRec"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 24
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/norcloud/sendAlerts')
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "on-value": "1",
      "off-value": "0"
    },
    model: {
      value: (_vm.getSettingsNorCloud.sendAlerts),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsNorCloud, "sendAlerts", $$v)
      },
      expression: "getSettingsNorCloud.sendAlerts"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/norcloud/recSett')
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "on-value": "1",
      "off-value": "0"
    },
    model: {
      value: (_vm.getSettingsNorCloud.receiveSett),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsNorCloud, "receiveSett", $$v)
      },
      expression: "getSettingsNorCloud.receiveSett"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 12,
      "lg": 12
    }
  }, [(_vm.getSettingsNorCloud.receiveSett == '1') ? _c('el-form-item', {
    staticClass: "el-form-item-full"
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/norcloud/applySett')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsNorCloud.updSett),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsNorCloud, "updSett", $$v)
      },
      expression: "getSettingsNorCloud.updSett"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/norcloud/now'),
      "value": "now"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/norcloud/fhour'),
      "value": "fhour"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/norcloud/break'),
      "value": "break"
    }
  })], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19280080","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/categories/NorCloud.vue
// module id = 445
// module chunks = 1